import { typographyTokens } from '../../../../theme/typographyTokens';
import React from 'react';
import { Paper, Typography, Alert } from '@mui/material';

const ResetInstructions: React.FC = () => {
  return (
    <Paper elevation={1} sx={{ p: 2, mt: 3, bgcolor: '#f5f5f5' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: typographyTokens.fontWeights.semibold, mb: 1 }}>
        Instructions:
      </Typography>
      <Typography variant="body2" component="div">
        <ol style={{ margin: 0, paddingLeft: 20 }}>
          <li>
            Select one or more SEPs from the left panel. Only SEPs with{' '}
            <strong>active status</strong> and <strong>initiate phase</strong>{' '}
            are shown.
          </li>
          <li>
            Select validation task templates from the right panel that you
            want to attach to the selected SEPs.
          </li>
          <li>
            Click the &quot;Reset to Validation Phase&quot; button to:
            <ul>
              <li>Create the selected validation tasks for each SEP</li>
              <li>
                Skip any tasks that already exist (based on task template ID)
              </li>
              <li>Unlock validation phase tasks</li>
              <li>Change the SEP phase back to validation</li>
            </ul>
          </li>
        </ol>
      </Typography>
      <Alert severity="info" sx={{ mt: 2 }}>
        <strong>Note:</strong> Duplicate tasks are automatically detected and
        skipped. Tasks are matched by their template ID.
      </Alert>
    </Paper>
  );
};

export default ResetInstructions;
